import { LoadableLazy } from '@confluence/loadable';

export const LoadableChangeEditionNotificationDialog = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ChangeEditionNotificationDialog" */ './ChangeEditionNotificationDialog.js'
			)
		).ChangeEditionNotificationDialog,
});
